import type { AlertColor } from "@mui/material/Alert/Alert";
import { Route, Routes } from "react-router-dom";

import useQueryClient from "../../api/query";
import { PaymentMethodsPage } from "./PaymentMethodsPage";
import { SuccessPage } from "./SuccessPage";
import { WelcomePage } from "./WelcomePage";

// import Loading from "../Loading";

interface PatientPortalProps {
  updateSnackBar: (snackbar: { severity: AlertColor; message: string }) => void;
}

export function PatientPortal({ updateSnackBar }: PatientPortalProps) {
  // TODO validation session & load practice information

  const queryClient = useQueryClient();

  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route
        path="/payment-methods"
        element={
          <PaymentMethodsPage
            queryClient={queryClient}
            updateSnackBar={updateSnackBar}
          />
        }
      />
      <Route path="/success" element={<SuccessPage />} />
    </Routes>
  );
}
